// Orden a pedido de una tabla, por columna (card Ni3pOCBx). Lógica PURA, sin React: la comparten
// la tabla del equipo en Usuarios (`TeamLearningTable`) y la de «Quién lo usa» del uso del portal.
//
// Tres reglas que no se negocian:
//  - **Estable.** Dos filas con el mismo valor conservan su orden de llegada, que es el del backend.
//  - **Lo que no tiene valor va AL FINAL en las dos direcciones.** Una persona que nunca entró no es
//    «la que menos usa»: ordenar de menor a mayor no la puede poner arriba de alguien con 1 consulta.
//  - **Sin dirección no se ordena**: devuelve el orden de llegada. Es el tercer clic del encabezado,
//    la vuelta al orden por defecto.

export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';

const isEmpty = (value) => value === null || value === undefined || Number.isNaN(value);

/**
 * Las filas ordenadas por `valueOf(row)` (un número o un string), sin tocar el array original.
 * `direction` = `SORT_ASC` | `SORT_DESC` | `null`.
 */
export function sortRows(rows, valueOf, direction) {
    const list = Array.isArray(rows) ? rows : [];
    if (!direction || typeof valueOf !== 'function') return list.slice();
    const sign = direction === SORT_DESC ? -1 : 1;
    return list
        .map((row, index) => ({row, index, value: valueOf(row)}))
        .sort((a, b) => {
            const aEmpty = isEmpty(a.value);
            const bEmpty = isEmpty(b.value);
            if (aEmpty || bEmpty) {
                if (aEmpty && bEmpty) return a.index - b.index;
                return aEmpty ? 1 : -1;
            }
            if (a.value < b.value) return -sign;
            if (a.value > b.value) return sign;
            return a.index - b.index;
        })
        .map(({row}) => row);
}

/**
 * El próximo estado al tocar el encabezado de `column`: primero `firstDirection`, después la
 * contraria y después sin orden. Tocar OTRA columna arranca de nuevo en su primera dirección.
 * El estado es `{column, direction}`; `{column: null, direction: null}` es el orden por defecto.
 */
export function nextSort(current, column, firstDirection = SORT_DESC) {
    const second = firstDirection === SORT_DESC ? SORT_ASC : SORT_DESC;
    if (!current || current.column !== column || !current.direction) {
        return {column, direction: firstDirection};
    }
    if (current.direction === firstDirection) return {column, direction: second};
    return {column: null, direction: null};
}

/** El `aria-sort` de un encabezado: `ascending` / `descending` / `none`. */
export function ariaSortOf(current, column) {
    if (!current || current.column !== column || !current.direction) return 'none';
    return current.direction === SORT_ASC ? 'ascending' : 'descending';
}
